import { Fragment } from "react";
import { VisuallyHidden as VisuallyHiddenAria } from "react-aria-components";

export const VisuallyHidden = ({ isHidden, children }) => {
  const Component = isHidden ? VisuallyHiddenAria : Fragment;
  return <Component>{children}</Component>;
};
